import { useMutation } from "@tanstack/react-query";
import { getNookClient } from "../client.js";
export function useStartCheckout(plan) {
    return useMutation({
        mutationFn: async () => (await getNookClient().startCheckout(plan)).checkoutUrl,
    });
}
//# sourceMappingURL=use-start-checkout.js.map